import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { App, ConfigProvider, theme } from 'antd';
import frFR from 'antd/locale/fr_FR';

const ThemeCtx = createContext({ mode: 'light', toggle: () => {} });
export const useAppTheme = () => useContext(ThemeCtx);

export const AppThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => localStorage.getItem('website-theme-mode') || 'light');
    useEffect(() => localStorage.setItem('website-theme-mode', mode), [mode]);

    const isDark = mode === 'dark';
    const value = useMemo(() => ({ mode, toggle: () => setMode(m => (m === 'light' ? 'dark' : 'light')) }), [mode]);

    return (
        <ThemeCtx.Provider value={value}>
            <ConfigProvider
                locale={frFR}
                theme={{
                    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
                    token: {
                        colorPrimary: '#1A2B5F',
                        colorLink: '#1A2B5F',
                        borderRadiusLG: 12,
                        fontFamily: "'Public Sans', sans-serif",
                    },
                    components: {
                        Layout: { headerBg: '#fff', footerBg: '#1A2B5F' },
                        Menu: {
                            itemHeight: 44,
                            itemSelectedBg: '#1A2B5F',
                            itemSelectedColor: '#fff',
                            itemHoverBg: '#eef1f8',
                        },
                        Button: {
                            colorPrimary: '#C8102E',
                            colorPrimaryHover: '#a50d24',
                            colorPrimaryActive: '#8c0b1f',
                        },
                    },
                }}
            >
                <App>{children}</App>
            </ConfigProvider>
        </ThemeCtx.Provider>
    );
};
